import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'antd';
import './style.scss'

class CustomerOverLimitModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    handleOk() {
        this.props.onClose()
    }

    handleCancel() {
        this.props.onClose()
    }

    render() {
        const { visible } = this.props
        return (
            <div className="home-page-wrapper">
                <Modal
                    title={" Over Limit Customer "}
                    visible={visible}
                    onOk={() => this.handleOk()}
                    onCancel={() => this.handleCancel()}
                >
                    <div style={{ textAlign: 'center' }}>
                        <h1>{'Over Limit Customer'}</h1>
                    </div>
                </Modal>
            </div>
        )
    }
}

CustomerOverLimitModal.propTypes = {
    onClose: PropTypes.func,
}

CustomerOverLimitModal.defaultProps = {
    visible: false,
};

const mapStateToProps = (state) => ({
    isAuthenticated: state.login.isAuthenticated,
    roleName: state.login.roleName,
})

export default connect(mapStateToProps)(CustomerOverLimitModal);

